import { createSelector } from 'reselect';
import get from 'lodash.get';
import { routes, navigationTabs } from '../../routes/constants';
import type { RootState } from '../../store/types';

const getCurrentPathname = (state: RootState) => state.router.location.pathname;

export const getShouldRenderMobileNavigation = createSelector(
  getCurrentPathname,
  (currentPathname) => {
    const basePathname = '/';
    const shouldRenderMobileNavigation = currentPathname === basePathname;
    return shouldRenderMobileNavigation;
  }
);

export const getIsMobile = (state: RootState) => {
  return state.ui.screenSize.isMobile;
};

export const getSelectedTab = createSelector(getCurrentPathname, (currentPathname) => {
  const selectedTab = navigationTabs.find((tab) => tab.path === currentPathname) || {};
  return selectedTab;
});

export const getBreadcrumbData = createSelector(getCurrentPathname, (currentPathname) => {
  const currentRoute = routes[currentPathname] || {};
  const breadcrumbData = {
    displayName: currentRoute.displayName || '',
    backUrl: currentRoute.breadcrumbBackUrl || ''
  };
  return breadcrumbData;
});

export const getShared = (state: RootState) => state.shared;

export const getAppSettings = createSelector(getShared, (shared) => {
  const appSettings = get(shared, 'appSettings', {});
  return appSettings;
});

export const getAccount2Config = createSelector(getAppSettings, (appSettings) => {
  const account2Config = get(appSettings, 'Account2Config', {});
  return account2Config;
});

export const getTabFeatureFlags = createSelector(getAccount2Config, (account2Config) => {
  const tabFeatureFlags = {
    shouldShowNotificationSettingsTab: get(
      account2Config,
      'notificationSettings.shouldShowNotificationSettingsTab'
    ),
    shouldShowFinancingTermsTab: get(account2Config, 'financingTerms.shouldShowFinancingTermsTab'),
    shouldShowReferralsTab: get(account2Config, 'referrals.shouldShowReferralsTab')
  };
  return tabFeatureFlags;
});

export const getNotificationSettingsFeatureFlags = createSelector(
  getAccount2Config,
  (account2Config) => {
    const notificationSettingsFeatureFlags = {
      shouldShowEmail: get(account2Config, 'notificationSettings.shouldShowEmail'),
      shouldShowSms: get(account2Config, 'notificationSettings.shouldShowSms'),
      shouldShowPhoneCall: get(account2Config, 'notificationSettings.shouldShowPhoneCall'),
      shouldShowTCPA: get(account2Config, 'notificationSettings.shouldShowTCPA')
    };
    return notificationSettingsFeatureFlags;
  }
);
